import * as React from 'react';
import axios from "axios";
import hoistoryStore from "../store/historyStore";
import { useEffect } from "react";

import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import InputBase from '@mui/material/InputBase';
import SearchIcon from '@mui/icons-material/Search';
import IconButton from '@mui/material/IconButton';
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import AddTaskIcon from '@mui/icons-material/AddTask';
import ListItemText from "@mui/material/ListItemText";
import CircularProgress from '@mui/material/CircularProgress';
import WbTwilightIcon from '@mui/icons-material/WbTwilight';
import LightModeIcon from '@mui/icons-material/LightMode';
import BedtimeIcon from '@mui/icons-material/Bedtime';
import FlareIcon from '@mui/icons-material/Flare';
import * as util from "../utils/util";


interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 0, borderTop: '1px solid #ccc', borderBottom: '1px solid #ccc' }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function BasicTabs() {
  const storeData: any = hoistoryStore();
  const [value, setValue] = React.useState(0);
  const [searchText, setSearchText] = React.useState('');
  const [searchMorningFoodList, setSearchMorningFoodList] = React.useState([]);
  const [searchLunchFoodList, setSearchLunchFoodList] = React.useState([]);
  const [searchDinnerFoodList, setSearchDinnerFoodList] = React.useState([]);
  const [searchSnackFoodList, setSearchSnackFoodList] = React.useState([]);
  const [showLoading, setShowLoading] = React.useState(false);

  // 아침/점심/저녁/간식 탭 이동
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setSearchText('');
    setValue(newValue);
    setSearchMorningFoodList([]);
    setSearchLunchFoodList([]);
    setSearchDinnerFoodList([]);
    setSearchSnackFoodList([]);
  };

  // 음식 검색
  function handleSearchFood() {
    if (searchText !== '') {
      setShowLoading(true);
      axios.get(`http://openapi.foodsafetykorea.go.kr/api/fa70626d725b4cf3a7cc/I2790/json/1/30/DESC_KOR=${encodeURIComponent(searchText)}`).then(res => {
        if (Number(res.data.I2790.total_count) > 0) {
          if (value === 0) setSearchMorningFoodList(res.data.I2790.row);
          if (value === 1) setSearchLunchFoodList(res.data.I2790.row);
          if (value === 2) setSearchDinnerFoodList(res.data.I2790.row);
          if (value === 3) setSearchSnackFoodList(res.data.I2790.row);
        }
        setShowLoading(false);
      }).catch(function (error) {
        console.log(error)
      });
    } else {
      alert('음식명을 입력하세요');
    }
  }

  // 검색한 음식 목록 중 음식 선택
  function handleSelectFood(div: any, index: any) {
    let selectedFoodInfo = { DESC_KOR: '', NUTR_CONT1: '' };
    if (div === 'morning') selectedFoodInfo = searchMorningFoodList[index];
    else if (div === 'lunch') selectedFoodInfo = searchLunchFoodList[index];
    else if (div === 'dinner') selectedFoodInfo = searchDinnerFoodList[index];
    else if (div === 'snack') selectedFoodInfo = searchSnackFoodList[index];
    let food = { gubun: div || '', name: selectedFoodInfo['DESC_KOR'] || '', calory: Number(selectedFoodInfo['NUTR_CONT1']), amount: 0.5 };
    let foodArr = [];
    if (storeData.selectedFoodList.some((item: any) => item.gubun === div && item.name === selectedFoodInfo['DESC_KOR'])) {  // 이미 선택된 음식
      foodArr = storeData.selectedFoodList.map((v: any) => v.gubun === div && v.name === selectedFoodInfo['DESC_KOR'] ? { ...v, amount: v.amount + 0.5 } : v);
    } else {  // 처음 선택된 음식
      foodArr = storeData.selectedFoodList.concat(food);
    }
    
    // 사용자가 추가한 음식이 최상단에 위차하여 사용자가 확인할 수 있도록 순서 변경
    const newFoodArr = [
      ...foodArr.filter((v: any) => v.gubun === div && v.name === selectedFoodInfo['DESC_KOR']),
      ...foodArr.filter((v: any) => !(v.gubun === div && v.name === selectedFoodInfo['DESC_KOR']))
    ];
      
    storeData.setSelectedFoodList(newFoodArr);
  }

  // 선택한 음식 목록 중 음식 선택 해제
  function handleUnselectFood(gubun: any, name: any) {
    let foodArr = [];
    if (storeData.selectedFoodList.some((item: any) => item.gubun === gubun && item.name === name && item.amount > 0.5)) {  // 해제한 음식의 카운트가 2 이상일 때 => 푸드 객체 count - 1
      foodArr = storeData.selectedFoodList.map((v: any) => v.gubun === gubun && v.name === name ? { ...v, amount: v.amount - 0.5 } : v);
    } else {  // 해제한 음식의 카운트가 1 일 때 => 배열에서 푸드 객체 삭제
      foodArr = storeData.selectedFoodList.filter((v: any) => !(v.gubun === gubun && v.name === name));
    }
    storeData.setSelectedFoodList(foodArr);
  }

  // 선택한 음식 목록 중 음식칼로리 추가
  function handleAddselectFood(gubun: any, name: any) {
    let foodArr = [];
    if (storeData.selectedFoodList.some((item: any) => item.gubun === gubun && item.name)) {
      foodArr = storeData.selectedFoodList.map((v: any) => v.gubun === gubun && v.name === name ? { ...v, amount: v.amount + 0.5 } : v);
    }
    storeData.setSelectedFoodList(foodArr);
  }

  function getKorGubun(gubun: any) {
    switch (gubun) {
      case 'morning': return <div className="morning" style={{ color: '#ef8322' }}><WbTwilightIcon /><br />아침</div>;
      case 'lunch': return <div className="lunch" style={{ color: '#fd5c5c' }}><LightModeIcon /><br />점심</div>;
      case 'dinner': return <div className="dinner" style={{ color: '#ffb70d' }}><BedtimeIcon /><br />저녁</div>;
      case 'snack': return <div className="snack" style={{ color: '#aa1eff' }}><FlareIcon /><br />간식</div>;
      default: return '';
    }
  }



  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={value} onChange={handleChange} aria-label="food tabs" textColor="secondary" indicatorColor="secondary">
          <Tab label="아침" {...a11yProps(0)} sx={{ minWidth: 70 }} />
          <Tab label="점심" {...a11yProps(1)} sx={{ minWidth: 70 }} />
          <Tab label="저녁" {...a11yProps(2)} sx={{ minWidth: 70 }} />
          <Tab label="간식" {...a11yProps(3)} sx={{ minWidth: 70 }} />
        </Tabs>
      </Box>
      <Box sx={{ pl: 1, pr: 1, bgcolor: '#f5f5f5', pt: 0.5, pb: 0.5 }}>
        <Paper component="form" sx={search_Fome_Style}>
          <InputBase
            sx={{ ml: 1, flex: 1, fontSize: 14 }}
            placeholder="음식명을 입력하세요"
            inputProps={{ 'aria-label': '음식명을 입력하세요' }}
            onChange={(e) => setSearchText(e.target.value)}
            value={searchText}
          />
          <IconButton type="button" sx={{ p: '10px' }} aria-label="search" onClick={handleSearchFood}>
            <SearchIcon />
          </IconButton>
        </Paper>
      </Box>


      {/* TODO :: 아래 중복 코드 나중에 FoodtabsList Component로 교체하기*/}
      <CustomTabPanel value={value} index={0} >
        <Box sx={{ display: showLoading ? 'flex' : 'none', justifyContent: 'center', alignContent: 'center', p: 1 }}>
          <CircularProgress color="secondary" />
        </Box>
        <Box sx={{ maxHeight: 200, overflow: 'auto', p: 1 }}>
          {!showLoading && searchMorningFoodList.length <= 0 ? (
            <Typography sx={{ fontSize: 14, textAlign: 'center', p: 1, color: '#EF8322' }}>음식이 없습니다.</Typography>
          ) : (
            searchMorningFoodList.map((food: any, index: any) => (
              <List sx={{ m: 1, border: '1px solid #ccc', p: 0.5, borderRadius: 3 }}>
                <ListItem onClick={() => handleSelectFood('morning', index)}
                  secondaryAction={
                    <IconButton aria-label="add" edge="end" onClick={() => handleSelectFood('morning', index)}>
                      <AddTaskIcon sx={{ color: '#EF8322' }} />
                    </IconButton>
                  }
                  sx={{ p: 0, pl: 1, pr: 1 }}
                >
                  <ListItemText>
                    <Typography sx={{ fontSize: 14, fontWeight: 700 }}>{food.DESC_KOR}</Typography>
                    <Typography sx={{ fontSize: 14, }}>{util.formatComma(food.NUTR_CONT1) + 'kcal'}</Typography>
                  </ListItemText>
                </ListItem>
              </List>
            )))}
        </Box>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
      <Box sx={{ display: showLoading ? 'flex' : 'none', justifyContent: 'center', alignContent: 'center', p: 1 }}>
          <CircularProgress color="secondary" />
        </Box>
        <Box sx={{ maxHeight: 200, overflow: 'auto', p: 1 }}>
          {!showLoading && searchLunchFoodList.length <= 0 ? (
            <Typography sx={{ fontSize: 14, textAlign: 'center', p: 1, color: '#EF8322' }}>음식이 없습니다.</Typography>
          ) : (
            searchLunchFoodList.map((food: any, index: any) => (
              <List sx={{ m: 1, border: '1px solid #ccc', p: 0.5, borderRadius: 3 }}>
                <ListItem onClick={() => handleSelectFood('lunch', index)}
                  secondaryAction={
                    <IconButton aria-label="add" onClick={() => handleSelectFood('lunch', index)}>
                      <AddTaskIcon sx={{ color: '#EF8322' }} />
                    </IconButton>
                  }
                  sx={{ p: 0, pl: 1, pr: 1 }}
                >
                  <ListItemText>
                    <Typography sx={{ fontSize: 14, fontWeight: 700, pr: 6 }}>{food.DESC_KOR}</Typography>
                    <Typography sx={{ fontSize: 14, }}>{util.formatComma(food.NUTR_CONT1) + 'kcal'}</Typography>
                  </ListItemText>
                </ListItem>
              </List>
            )))}
        </Box>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={2}>
      <Box sx={{ display: showLoading ? 'flex' : 'none', justifyContent: 'center', alignContent: 'center', p: 1 }}>
          <CircularProgress color="secondary" />
        </Box>
        <Box sx={{ maxHeight: 200, overflow: 'auto', p: 1 }}>
          {!showLoading && searchDinnerFoodList.length <= 0 ? (
            <Typography sx={{ fontSize: 14, textAlign: 'center', p: 1, color: '#EF8322' }}>음식이 없습니다.</Typography>
          ) : (
            searchDinnerFoodList.map((food: any, index: any) => (
              <List sx={{ m: 1, border: '1px solid #ccc', p: 0.5, borderRadius: 3 }}>
                <ListItem onClick={() => handleSelectFood('dinner', index)}
                  secondaryAction={
                    <IconButton aria-label="add" onClick={() => handleSelectFood('dinner', index)}>
                      <AddTaskIcon sx={{ color: '#EF8322' }} />
                    </IconButton>
                  }
                  sx={{ p: 0, pl: 1, pr: 1 }}
                >
                  <ListItemText>
                    <Typography sx={{ fontSize: 14, fontWeight: 700, pr: 6 }}>{food.DESC_KOR}</Typography>
                    <Typography sx={{ fontSize: 14, }}>{util.formatComma(food.NUTR_CONT1) + 'kcal'}</Typography>
                  </ListItemText>
                </ListItem>
              </List>
            )))}
        </Box>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={3}>
      <Box sx={{ display: showLoading ? 'flex' : 'none', justifyContent: 'center', alignContent: 'center', p: 1 }}>
          <CircularProgress color="secondary" />
        </Box>
        <Box sx={{ maxHeight: 200, overflow: 'auto', p: 1 }}>
          {!showLoading && searchSnackFoodList.length <= 0 ? (
            <Typography sx={{ fontSize: 14, textAlign: 'center', p: 1, color: '#EF8322' }}>음식이 없습니다.</Typography>
          ) : (
            searchSnackFoodList.map((food: any, index: any) => (
              <List sx={{ m: 1, border: '1px solid #ccc', p: 0.5, borderRadius: 3 }}>
                <ListItem  onClick={() => handleSelectFood('snack', index)}
                  secondaryAction={
                    <IconButton aria-label="add" onClick={() => handleSelectFood('snack', index)}>
                      <AddTaskIcon sx={{ color: '#EF8322' }} />
                    </IconButton>
                  }
                  sx={{ p: 0, pl: 1, pr: 1 }}
                >
                  <ListItemText>
                    <Typography sx={{ fontSize: 14, fontWeight: 700, pr: 6 }}>{food.DESC_KOR}</Typography>
                    <Typography sx={{ fontSize: 14, }}>{util.formatComma(food.NUTR_CONT1) + 'kcal'}</Typography>
                  </ListItemText>
                </ListItem>
              </List>
            )))}
        </Box>
      </CustomTabPanel>
      <Box sx={{
        maxHeight: 240, overflow: 'auto', bgcolor: '#f5f5f5', borderRadius: '0 0 15px 15px', p: 1,

        '& .mealList:last-child': { borderRadius: '0 0 15px 15px' }
      }}>
        {storeData.selectedFoodList.filter((item: any) => item.name !== '').map((food: any, index: any) => (
          <Box className='mealList' sx={{ p: 1, pt: 0.5, pb: 0.5 }}>
            <Stack direction='row' justifyContent={'center'} alignItems={'center'} sx={{ bgcolor: '#fff', borderRadius: 2, p: 1, border: '1px solid #ddd' }}>
              <Typography component={'div'} sx={{ fontSize: 14, fontWeight: 700, width: '12%', textAlign: 'center' }}>
                {getKorGubun(food.gubun)}
              </Typography>
              <Typography component={'div'} sx={{ fontSize: 14, width: '40%', textAlign: 'center' }}>
                {food.name}<br />
                <span style={{ fontWeight: 700 }}>{food.calory}</span> kcal
              </Typography>
              <Typography component={'div'} sx={{ fontSize: 14, width: '30%', textAlign: 'center' }}>
                {food.amount}인분<br />
                <span style={{ fontWeight: 700 }}>{util.formatComma((food.calory * food.amount).toFixed(2))}</span> kcal
              </Typography>
              <IconButton aria-label="add" onClick={() => handleAddselectFood(food.gubun, food.name)} sx={{ width: '9%', textAlign: 'center' }}>
                <AddCircleOutlineIcon sx={{ color: '#5d86ff', fontSize:30  }} />
              </IconButton>
              <IconButton aria-label="remove" onClick={() => handleUnselectFood(food.gubun, food.name)} sx={{ width: '9%', textAlign: 'center' }}>
                <RemoveCircleOutlineIcon sx={{ color: '#f54d4d', fontSize:30  }} />
              </IconButton>
            </Stack>
          </Box>
        ))}
      </Box>
    </Box>
  );
}

const search_Fome_Style = {
  m: '10px auto',
  p: '0px 10px',
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  borderRadius: '24px',
  boxShadow: 'inset 0 0 4px rgba(0,0,0,0.4)',
  boxSizing: 'border-box'
};